/**
 * GameLoop — Uses PixiJS ticker to drive updates.
 * Calls SceneManager.update(dt) each frame and tracks FPS.
 */
import sceneManager from './SceneManager.js';
import inputManager from '../input/InputManager.js';

class GameLoop {
  constructor() {
    this._ticker = null;
    this._fps = 0;
    this._frameCount = 0;
    this._fpsAccumulator = 0;
    this._running = false;
  }

  /**
   * Start the game loop using the PixiJS app ticker.
   * @param {import('pixi.js').Application} app - The PixiJS application
   */
  start(app) {
    if (this._running) return;
    this._running = true;
    this._ticker = app.ticker;

    this._ticker.add((ticker) => {
      const dt = ticker.deltaTime / 60; // Convert to seconds (ticker.deltaTime is in frames at 60fps)
      const elapsedMS = ticker.elapsedMS;

      // FPS tracking
      this._frameCount++;
      this._fpsAccumulator += elapsedMS;
      if (this._fpsAccumulator >= 1000) {
        this._fps = Math.round((this._frameCount * 1000) / this._fpsAccumulator);
        this._frameCount = 0;
        this._fpsAccumulator = 0;
      }

      // Update input (gamepad polling, per-frame state)
      inputManager.update();

      // Update scene
      sceneManager.update(dt);
    });
  }

  /**
   * Get current FPS.
   * @returns {number}
   */
  getFps() {
    return this._fps;
  }

  /**
   * Stop the game loop.
   */
  stop() {
    if (this._ticker) {
      this._ticker.stop();
    }
    this._running = false;
  }
}

const gameLoop = new GameLoop();
export default gameLoop;
